import { API_EXPRESS_URLS, APP_ENVIROMENT_TYPE } from './types';

const API_EXPRESS_ENVIRONMENTS = {
  defaultValue: API_EXPRESS_URLS.PRODUCTION,
  development: API_EXPRESS_URLS.DEVELOPMENT,
  staging: API_EXPRESS_URLS.STAGING,
  sandbox: API_EXPRESS_URLS.SANDBOX,
  sustaining: API_EXPRESS_URLS.SUSTAINING,
  production: API_EXPRESS_URLS.PRODUCTION,
};

const getEnvExpressApiUrl = (env: APP_ENVIROMENT_TYPE | string): string => {
  return API_EXPRESS_ENVIRONMENTS[env] || API_EXPRESS_ENVIRONMENTS.defaultValue;
};

export { getEnvExpressApiUrl };
